'use strict';

const { h } = require('phy');

const Header = require('../../shared/views/header');
const MainTitle = require('../../coupons/views/main-title');
const SecondaryTitle = require('../../coupons/views/secondary-title');
const BrowseLetter = require('./browse-letter');
const BrowseMerchant = require('./browse-merchant');
const SidebarMerchant = require('../../merchant/views/sidebar-browse-merchant');

function AllBrands({ payload, deps }) {
  const {
    keyAuthData,
    seoMetaData: { h1Override },
    navigationMerchants,
    popularMerchants,
    allBrandMerchants,
  } = payload;
  const { routes } = deps;

  return h('article', [
    h(Header, {
      routes,
      activePage: 'all-brands',
      keyAuthData,
      merchants: navigationMerchants,
    }),
    h('section.container', [
      h('.layout', [
        h('.layout-content', [
          h(MainTitle, {
            h1Override,
            resourceKey: 'modules.merchant.AlphaPageHeading',
          }),
          h(SecondaryTitle, {
            resourceKey: 'modules.merchant.AlphaPageSubHeading',
          }),
          h(BrowseLetter, { merchants: allBrandMerchants }),
          h(BrowseMerchant, { routes, merchants: allBrandMerchants }),
        ]),
        h('.layout-sidebar', [
          h(SidebarMerchant, {
            routes,
            merchants: popularMerchants,
            localisation: {
              resource: 'modules.shared.TopBrands',
              data: { tag: 'h3', attrs: { class: 'sidebar-browse-title' } },
            },
            bloodhound: 'PopularStores',
          }),
        ]),
      ]),
    ]),
  ]);
}

module.exports = AllBrands;
